<mat-tab-group (selectedTabChange)="tabChanged($event)" [selectedIndex]="tabSelectedIndex">
    @for (item of tabList; track $index; let i = $index) {
<mat-tab label="{{item.label}}"></mat-tab>
}
</mat-tab-group>



